import { render, staticRenderFns } from "./article3.vue?vue&type=template&id=fd653d92"
import script from "./article3.vue?vue&type=script&lang=js"
export * from "./article3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports